/**
 * Ihis is a lightweight(temporary) version of the useLogger.js file.
 * The reason for this is that we are currently having issues of adding AsyncLocalStorage in this app.
 * We will need to revisit this in the future to seek the chance to use AsyncLocalStorage
 * 
 */
export default () => {
  /**
   * This function wraps up a function call and surrounds the call with timing logs.
   * It accepts a name ( usually the name of the function or description of the operation ), a delegate function
   * and any number of arguments to pass to the delegate function.
   */
  const withTimings = async (name, delegateFunction, ...args) => {
    const startTime = Date.now()
    const retVal = await delegateFunction(...args)
    const endTime = Date.now()
    const latency = endTime - startTime
    const timings = {
      name,
      start: new Date(startTime).toISOString(),
      end: new Date(endTime).toISOString(),
      latencyInMillis: latency,
    }
    // console.log(timings)
    return retVal
  }

  return { withTimings }
}
